<div class="plot-card overflow-hidden">
    <canvas #V_MAXCanvas></canvas>
</div>